// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 25) return "./default/chunk-html-box-reg-wall.fc553557940634d9ab50.js";
	if (chunkId === 35) return "./default/chunk-recombee-init.f574ae248600058b3f12.js";
	if (chunkId === 26) return "./default/chunk-lazyload-images.ad44878869483f165cd2.js";
	if (chunkId === 23) return "./default/chunk-gtm-highlight.4d665c80f67e68f4bf49.js";
	if (chunkId === 33) return "./default/chunk-progressBar.a904b58d56d01e998274.js";
	if (chunkId === 15) return "./default/chunk-accordion.7cad5083f01d4e13ab0a.js";
	if (chunkId === 20) return "./default/chunk-fadeInOnEnterViewport.ff4dc0c559bf9a13de43.js";
	if (chunkId === 29) return "./default/chunk-megamenu.2f7b3fd882109dd3c321.js";
	if (chunkId === 24) return "./default/chunk-header.9c1aa191de28744374fe.js";
	if (chunkId === 28) return "./default/chunk-mainNavigation.9b5500120cce2634c0a1.js";
	if (chunkId === 30) return "./default/chunk-modal.6ff867240eb90ec213af.js";
	if (chunkId === 66) return "./66.cf0bce202ebef53caad9.js";
	if (chunkId === 22) return "./default/chunk-gallery.461d723aedf5d2da0987.js";
	if (chunkId === 19) return "./default/chunk-enquiry.e33f30b0312c78882a8a.js";
	if (chunkId === 39) return "./default/chunk-survey.ab5e55ab8e0ac56c20bb.js";
	if (chunkId === 21) return "./default/chunk-forum.4b5d3d24a637d387196c.js";
	if (chunkId === 62) return "./62.98886249471ac27cbdd8.js";
	if (chunkId === 34) return "./default/chunk-recombee.2a988e1e63060b04b5ef.js";
	if (chunkId === 63) return "./63.d19c2c959bcb7df00724.js";
	if (chunkId === 27) return "./default/chunk-load-more.c0c853a80dec4692ef8c.js";
	if (chunkId === 41) return "./default/chunk-uncover-behav-articles.317b1742bdb354b1cbd6.js";
	if (chunkId === 16) return "./default/chunk-ads-repeater.2b8f03ffdb9354a29dd3.js";
	if (chunkId === 48) return "./default/newsletter.ac5657a9def0611af3ba.js";
	if (chunkId === 43) return "./default/companySubscription.82de06dc553eb32b5c52.js";
	if (chunkId === 51) return "./default/swiper.aea7692874aee71d7641.js";
	if (chunkId === 53) return "./default/thingsArticleSwiper.0b60c06d9cfb8f1c322d.js";
	if (chunkId === 18) return "./default/chunk-editorial-promo.a3c3596efac768bca62d.js";
	if (chunkId === 54) return "./default/topic-banner.7c1fbb8184c3adf82208.js";
	if (chunkId === 46) return "./default/instagram.dd18842a7ccb3875399c.js";
	if (chunkId === 49) return "./default/piano.34088573d0b1a2dd5318.js";
	if (chunkId === 64) return "./64.1e0d18b7a55eadf85f62.js";
	if (chunkId === 50) return "./default/portaInit.f66d3de1662e473dc7c5.js";
	if (chunkId === 47) return "./default/jakebox.f8253255a7db4958f6dc.js";
	if (chunkId === 42) return "./default/collapser.47407bc27b5958e7bef5.js";
	if (chunkId === 14) return "./default/author-card-list.2637f9603418ada7d05f.js";
	if (chunkId === 12) return "./chunk-todayResultSliderHP.45635dc8d4e1424e0d08.js";
	if (chunkId === 7) return "./chunk-previewMatchesListVideoSlider.ff891b752249536e4bda.js";
	if (chunkId === 5) return "./chunk-headermenuflat.e50d8c4b9b1bf4303973.js";
	if (chunkId === 45) return "./default/info-toggle.7893cb97482a05b3ac11.js";
	if (chunkId === 52) return "./default/tabs.ce52ac044c231255fbaf.js";
	if (chunkId === 11) return "./chunk-sportmodDayResultDatepicker.eea213b0d40ff81f5128.js";
	if (chunkId === 65) return "./65.1ef608a24f0a0fc70c93.js";
	if (chunkId === 9) return "./chunk-sportmod-live-match-websocket-updater.bf665cb5582abff99868.js";
	if (chunkId === 8) return "./chunk-sportmod-league-phase-reloader.153a00d29c43ca10f8b9.js";
	if (chunkId === 10) return "./chunk-sportmod-matches-with-table-phase-reloader.fcaa2e66def49ac8c5fe.js";
	if (chunkId === 4) return "./chunk-category-content-loader.4524784d66143a83f7fa.js";
	if (chunkId === 13) return "./chunk-top-feed-responsive-behavior.88ca9e2063392023d200.js";
	// return url for filenames based on template
	return undefined;
};